(function($) {

	'use strict';

	var init = function() {
        
        managePopups();

    };
    
    var managePopups = function() {

        $('[data-popup]').each(function() {
            var id = $(this).data('popup');
            $(this).click(function() {
                $('#' + id).addClass('active');
            });
        });
        $('.popup-modal').each(function() {
            $(this).click(function() {
                $(this).removeClass('active');
            });
        });
        $('.popup-modal__container').each(function() {
            $(this).click(function(e) {
                e.stopPropagation();
            });
        });
        $('.popup-modal__button').each(function() {
            $(this).click(function(e) {
                $(this).parent().parent().removeClass('active');
            });
        });
        
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);